import React, {useContext} from "react"
import {useTranslation} from "next-i18next"
import Typography from "../reusable/Typography/Typography"
import {X} from "react-bootstrap-icons"
import Button from "../reusable/components/Button"
import {gaCategories, gaEvents} from "../../config/googleAnalytics/events"
import AnalyticsContext from "../../context/AnalyticsContext"

type Props = {
    bike: any
    onRemoveItem: (id:number) => void
    index: number
    lengthCheckedProducts: number
}

const ComparisonItemTopPart: React.FC<Props> = ({bike, onRemoveItem, index, lengthCheckedProducts}) => {
	const {t} = useTranslation()
	const {images, name, slug} = bike
	const productUrl = `/${t("produkt")}/${slug}`
	const {reactGA} = useContext(AnalyticsContext)

	return (
		<div className="col-5 col-lg-4 d-flex flex-column justify-content-between">
			<div style={{height: "100%"}}
				className="pe-3 pe-lg-5 d-flex flex-column justify-content-between">
				<div>
					<div className="position-relative d-flex justify-content-end">
						<X className="position-absolute"
							size={20}
							color={"dark"}
							onClick={() => {
								onRemoveItem(slug)
								reactGA?.event({
									category: gaCategories.comparisonPage,
									action: gaEvents.removeProductFromComparison,
									label: gaEvents.removeProductFromComparison,
									nonInteraction: false
								})
							}} />
					</div>
					<div className="d-flex justify-content-center">
						<div className={"col-10 col-lg-6"}>
							<img src={images[0]?.src}
								width={"100%"}
								height={"auto"}/>
						</div>
					</div>
					<Typography className=""
						variant="bodyLg">{t(`${name}`)}</Typography>
				</div>
				<div className="d-none d-md-block">
					<Button href={productUrl}
						className="w-100 mt-3"
						label={t("more-information")}
						color="#212529"
						textColor="#212529"
						bgColor="#FEC04D"/>

				</div>
				<div className="d-md-none">
					<Button href={productUrl}
						className="w-100 mt-3"
						label={t("more-information")}
						btnFontSize={10}
						color="#212529"
						textColor="#212529"
						bgColor="#FEC04D"/>

				</div>
			</div>
			{lengthCheckedProducts > 3 && <div className={`d-none d-md-block ${lengthCheckedProducts === index + 1 && "pe-3 pe-lg-5"}`}>
				<hr/>
			</div>}
			{lengthCheckedProducts > 2 && <div className={`d-md-none ${lengthCheckedProducts === index + 1 && "pe-3 pe-lg-5"}`}>
				<hr/>
			</div>}
		</div>

	)
}

export default ComparisonItemTopPart
